import { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaFileInvoiceDollar, FaSave, FaMoneyBillWave, FaExchangeAlt, FaUndo } from 'react-icons/fa';
import { LuRefreshCw } from 'react-icons/lu';
import styles from "./corte.module.css";
import { api } from '../utils/services/api';
import Swal from 'sweetalert2';
import WindowLayout from '../utils/layout/windowsLayout';
import Select from 'react-select';
import { SERVICE } from '../utils/constants/services';
import { IoMdPrint } from 'react-icons/io';
import 'react-tabs/style/react-tabs.css';
import CorteModal from './corteModal';

import { downloadPDFFromBase64, isMobileDevice, openPDFInNewWindow } from '../utils/downloadUtils';



export default function Corte(props) {
    const { userId, setMenuActual, permisos } = useAuth();

    const [sucursales, setSucursales] = useState([]);
    const [sucursalSelect, setSucursalSelect] = useState(null);
    const [fecha, setFecha] = useState(new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
    }).split('/').reverse().join('-'));
    const [loading, setLoading] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [dataTotals, setDataTotals] = useState({});
    const [dataEmployees, setDataEmployees] = useState({});
    const [tipo, setTipo] = useState(1);
    const [show, setShow] = useState(false);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [editingField, setEditingField] = useState({ advisorId: null, field: null, value: '' });
    const [tcValues, setTcValues] = useState({});
    const [granTotalCashUser, setGranTotalCashUser] = useState(null);
    const [granTotalTransferUser, setGranTotalTransferUser] = useState(null);

    // Limpiar tcValues y overrides cuando cambia la fecha o sucursal
    useEffect(() => {
        setTcValues({});
        setGranTotalCashUser(null);
        setGranTotalTransferUser(null);
    }, [fecha, sucursalSelect]);

    // Prefill tcValues desde los registros existentes
    useEffect(() => {
        setTcValues(prev => {
            const merged = { ...prev };
            dataTable.forEach(row => {
                if (row.totalBilling && row.totalBilling !== null && merged[row.advisorId] === undefined) {
                    merged[row.advisorId] = {
                        cash: row.totalBilling.cashAmount || 0,
                        transfer: row.totalBilling.transferAmount || 0
                    };
                }
            });
            return merged;
        });
    }, [dataTable]);

    const handleSaveSingleField = (row, field, newValue) => {
        const amountAT = row.amountAT || 0;
        const valueNum = parseFloat(newValue || 0);
        
        if (valueNum < 0) {
            Swal.fire('Valor inválido', 'El monto no puede ser negativo.', 'warning');
            return false;
        }
        
        const prefill = tcValues[row.advisorId];
        const currentCash = prefill ? prefill.cash : (row.totalBilling && row.totalBilling.cashAmount !== undefined ? row.totalBilling.cashAmount : 0);
        const currentTransfer = prefill ? prefill.transfer : (row.totalBilling && row.totalBilling.transferAmount !== undefined ? row.totalBilling.transferAmount : 0);
        
        const cashNum = field === 'cash' ? valueNum : parseFloat(currentCash || 0);
        const transferNum = field === 'transfer' ? valueNum : parseFloat(currentTransfer || 0);
        
        // if ((cashNum + transferNum) > amountAT) {
        //     Swal.fire('Excede el máximo', 'La suma efectivo + transferencia no debe superar el TC.', 'error');
        //     return false;
        // }
        
        const existingId = (row.totalBilling && row.totalBilling.id) ? row.totalBilling.id : 0;
        let payload = {
            AdvisorId: row.advisorId,
            CashAmount: cashNum,
            TransferAmount: transferNum,
            Date: fecha
        };
        if (existingId && existingId !== 0) {
            payload.Id = existingId;
        }
        const endpoint = existingId && existingId !== 0 ? SERVICE.updateTcAmountsPut : SERVICE.updateTcAmounts;
        const method = existingId && existingId !== 0 ? "PUT" : "POST";
        api(endpoint, payload, method).then(() => {
            setTcValues(prev => ({ ...prev, [row.advisorId]: { cash: cashNum, transfer: transferNum } }));
            setEditingField({ advisorId: null, field: null, value: '' });
        }).catch(() => {
            Swal.fire('Error', 'No se pudo actualizar el monto.', 'error');
        });
        return true;
    };
    const corteBloqueado = dataTotals.id && dataTotals.id !== 0;
    useEffect(() => {
        if (corteBloqueado) {
            setEditingField({ advisorId: null, field: null, value: '' });
        }
    }, [corteBloqueado]);

    const columns = [
        {
            name: '#',
            selector: row => row.rowNumber,
            width: "80px"
        },
        {
            name: 'Asesor',
            selector: row => row.advisorName,
            wrap: true,
            cell: (row) => (
                <div style={{ width: "100%", textAlign: "left" }}>
                    {row.advisorName ? row.advisorName : 'Sin nombre'}
                </div>
            )
        },
        {
            name: <div style={{ width: "100%", textAlign: "center" }}>Clientes</div>,
            selector: row => row.cantClients,
            wrap: true,
            cell: (row) => (
                <div style={{ width: "100%", textAlign: "center" }}>
                    {row.cantClients ? row.cantClients : '0'}
                </div>
            ),
            width: "80px"
        },
        {
            name: <div style={{ width: '100%', textAlign: 'center' }}>  CARTERA REAL</div>,
            selector: row => `$ ${row.amount ? row.amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`,
            wrap: true,
            cell: (row) => (
                <div style={{ width: '100%', textAlign: 'right' }}>
                    {row.amount ? `$ ${row.amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$ 0.00'}
                </div>
            ),
            width: '115px'
        },
        {
            name: <div style={{ width: '100%', textAlign: 'center' }}>  CARTERA C/INTERES</div>,
            selector: row => `$ ${row.amountPayable ? row.amountPayable.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`,
            wrap: true,
            cell: (row) => (
                <div style={{ width: '100%', textAlign: 'right' }}>
                    {row.amountPayable ? `$ ${row.amountPayable.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$ 0.00'}
                </div>
            ),
            width: '115px'
        },
        {
            name: <div style={{ width: '100%', textAlign: 'center' }}>TC</div>,
            selector: row => `$ ${row.amountAT ? row.amountAT.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}`,
            wrap: true,
            cell: (row) => (
                <div style={{ width: '100%', textAlign: 'right' }}>
                    {row.amountAT ? `$ ${row.amountAT.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$ 0.00'}
                </div>
            ),
            width: '115px'
        },

        {
            name: <div style={{ width: "100%", textAlign: "center" }}>Pendiente</div>,
            selector: row => `$ ${row.totalAmountPendingPayment ? row.totalAmountPendingPayment.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : "0.00"}`,
            wrap: true,
            cell: (row) => (
                <div style={{ width: "100%", textAlign: "right" }}>
                    {row.totalAmountPendingPayment ? `$ ${row.totalAmountPendingPayment.toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}` : "0.00"}
                </div>
            ),
            width: "125px"
        },
        {
            name: <div style={{ width: '100%', textAlign: 'center' }}>Efectivo/Transferencia</div>,
            selector: row => {
                const prefill = tcValues[row.advisorId];
                const cash = prefill ? prefill.cash : (row.totalBilling && row.totalBilling.cashAmount !== undefined ? row.totalBilling.cashAmount : 0);
                const transfer = prefill ? prefill.transfer : (row.totalBilling && row.totalBilling.transferAmount !== undefined ? row.totalBilling.transferAmount : 0);
                return `${cash}/${transfer}`;
            },
            wrap: true,
            cell: (row) => {
                const prefill = tcValues[row.advisorId];
                const cash = prefill ? prefill.cash : (row.totalBilling && row.totalBilling.cashAmount !== undefined ? row.totalBilling.cashAmount : 0);
                const transfer = prefill ? prefill.transfer : (row.totalBilling && row.totalBilling.transferAmount !== undefined ? row.totalBilling.transferAmount : 0);

                const isEditingCash = editingField.advisorId === row.advisorId && editingField.field === 'cash';
                const isEditingTransfer = editingField.advisorId === row.advisorId && editingField.field === 'transfer';

                return (
                    <div style={{ width: '100%', textAlign: 'right', position: 'relative' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
                            {/* Campo Efectivo */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: '100%', justifyContent: 'flex-end' }}>
                                <FaMoneyBillWave style={{ color: '#28a745', fontSize: '12px' }} />
                                {!corteBloqueado && isEditingCash ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <input
                                            type='number'
                                            autoFocus
                                            style={{ 
                                                fontSize: '11px', 
                                                padding: '2px 4px', 
                                                width: '80px',
                                                border: '1px solid #0d6efd',
                                                borderRadius: '3px'
                                            }}
                                            value={editingField.value}
                                            onChange={(e) => setEditingField(prev => ({ ...prev, value: e.target.value }))}
                                            onBlur={() => setEditingField({ advisorId: null, field: null, value: '' })}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSaveSingleField(row, 'cash', editingField.value);
                                                } else if (e.key === 'Escape') {
                                                    setEditingField({ advisorId: null, field: null, value: '' });
                                                }
                                            }}
                                        />
                                        <button
                                            type='button'
                                            style={{
                                                fontSize: '10px',
                                                padding: '2px 6px',
                                                background: '#28a745',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                fontWeight: '600'
                                            }}
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                handleSaveSingleField(row, 'cash', editingField.value);
                                            }}
                                        >
                                            ✓
                                        </button>
                                    </div>
                                ) : (
                                    <span 
                                        style={{ fontSize: '11px', cursor: corteBloqueado ? 'default' : 'pointer', textDecoration: corteBloqueado ? 'none' : 'underline' }}
                                        className={styles.tcClickable}
                                        onClick={() => {
                                            if (!corteBloqueado) setEditingField({ advisorId: row.advisorId, field: 'cash', value: cash.toString() })
                                        }}
                                    >
                                        $ {(cash || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </span>
                                )}
                            </div>
                            
                            {/* Campo Transferencia */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', width: '100%', justifyContent: 'flex-end' }}>
                                <FaExchangeAlt style={{ color: '#0d6efd', fontSize: '12px' }} />
                                {!corteBloqueado && isEditingTransfer ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <input
                                            type='number'
                                            autoFocus
                                            style={{ 
                                                fontSize: '11px', 
                                                padding: '2px 4px', 
                                                width: '80px',
                                                border: '1px solid #0d6efd',
                                                borderRadius: '3px'
                                            }}
                                            value={editingField.value}
                                            onChange={(e) => setEditingField(prev => ({ ...prev, value: e.target.value }))}
                                            onBlur={() => setEditingField({ advisorId: null, field: null, value: '' })}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSaveSingleField(row, 'transfer', editingField.value);
                                                } else if (e.key === 'Escape') {
                                                    setEditingField({ advisorId: null, field: null, value: '' });
                                                }
                                            }}
                                        />
                                        <button
                                            type='button'
                                            style={{
                                                fontSize: '10px',
                                                padding: '2px 6px',
                                                background: '#0d6efd',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '3px',
                                                cursor: 'pointer',
                                                fontWeight: '600'
                                            }}
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                handleSaveSingleField(row, 'transfer', editingField.value);
                                            }}
                                        >
                                            ✓
                                        </button>
                                    </div>
                                ) : (
                                    <span 
                                        style={{ fontSize: '11px', cursor: corteBloqueado ? 'default' : 'pointer', textDecoration: corteBloqueado ? 'none' : 'underline' }}
                                        className={styles.tcClickable}
                                        onClick={() => {
                                            if (!corteBloqueado) setEditingField({ advisorId: row.advisorId, field: 'transfer', value: transfer.toString() })
                                        }}
                                    >
                                        $ {(transfer || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                );
            },
            width: '150px'
        },
    ];
    // Cálculo base de totales efectivos y transferencia desde distribuciones
    const computeTotalsCashTransfer = () => {
        const totalCash = dataTable.reduce((sum, row) => {
            const prefill = tcValues[row.advisorId];
            const cash = prefill ? prefill.cash : (row.totalBilling && row.totalBilling.cashAmount !== undefined ? row.totalBilling.cashAmount : 0);
            return sum + (parseFloat(cash) || 0);
        }, 0);
        const totalTransfer = dataTable.reduce((sum, row) => {
            const prefill = tcValues[row.advisorId];
            const transfer = prefill ? prefill.transfer : (row.totalBilling && row.totalBilling.transferAmount !== undefined ? row.totalBilling.transferAmount : 0);
            return sum + (parseFloat(transfer) || 0);
        }, 0);
        return { totalCash, totalTransfer };
    };
    const { totalCash: totalCashComputed, totalTransfer: totalTransferComputed } = computeTotalsCashTransfer();
    const effectiveCashDisplay = granTotalCashUser !== null ? granTotalCashUser : totalCashComputed;
    const effectiveTransferDisplay = granTotalTransferUser !== null ? granTotalTransferUser : totalTransferComputed;
    const handleDownload = () => {
        if (fecha !== "" && fecha !== null && sucursalSelect !== null) {
            // Verificar si tiene permisos para editar corte
            const tienePermisoEditar = permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1;

            // Verificar si el corte ya está hecho
            if (dataTotals.id === 0 || dataTotals.id === undefined) {
                // El corte no está hecho
                if (tienePermisoEditar) {
                    // Tiene permisos, preguntar si quiere hacerlo
                    Swal.fire({
                        title: "El corte de caja no se ha realizado",
                        text: `¿Desea realizar el corte de caja del día ${fecha} y sucursal: ${sucursalSelect.label} antes de descargar el reporte?`,
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonText: "Sí, hacer corte y descargar",
                        cancelButtonText: "No, solo descargar reporte",
                        confirmButtonColor: "#079459",
                        cancelButtonColor: "#6c757d"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Hacer el corte primero y luego descargar
                            handleCorteAndDownload();
                        } else {
                            // Solo descargar el reporte
                            downloadReport();
                        }
                    });
                } else {
                    Swal.fire({
                        title: "Sin permisos para editar corte",
                        text: "No tiene permisos para realizar el corte de caja. Solo se descargará el reporte.",
                        icon: "warning",
                        confirmButtonText: "Descargar reporte",
                        cancelButtonText: "Cancelar",
                        showCancelButton: true,
                        confirmButtonColor: "#079459",
                        cancelButtonColor: "#6c757d",
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            downloadReport();
                        }
                    });
                }
            } else {
                downloadReport();
            }
        }
    }

    const downloadReport = () => {
        setLoadingPrint(true);

        api(SERVICE.getCortePrint + `?date=${fecha}&centralOfficeId=${sucursalSelect.value}`)
            .then((data) => {
                if (data.data.data) {
                    const info = data.data.data;
                    const fileName = "Corte_caja_" + fecha + ".pdf";

                    const success = downloadPDFFromBase64(info, fileName);

                    if (!success && isMobileDevice()) {
                        openPDFInNewWindow(info);
                    }
                } else {
                    setDataTable([]);
                    setDataTotals({});
                }
            })
            .catch((err) => {
                console.log(err);
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Error al descargar el reporte",
                    text: "Inténtalo de nuevo",
                    showConfirmButton: true
                });
            })
            .finally(() => {
                setLoadingPrint(false);
            })
    }

    const handleCorteAndDownload = () => {
        let payload = {
            "Billing": dataTotals.billing,
            "Liquidations": dataTotals.liquidations,
            "Recoveries": dataTotals.recoveries,
            "AdvancePayments": dataTotals.advancePayments,
            "Disbursements": dataTotals.disbursements,
            "PreviousCut": dataTotals.previousCut,
            "TotalContributions": dataTotals.totalContributions,
            "TotalDeductions": dataTotals.totalDeductions,
            "PartialPayments": dataTotals.partialPayments,
            "GranTotal": dataTotals.granTotal,
            "BillingEmployees": dataTotals.billingEmployees,
            "DisbursementsEmployees": dataTotals.disbursementsEmployees,
            "BillingEmployeesItems": dataTotals.billingEmployeesItems,
            "DisbursementsEmployeesItems": dataTotals.disbursementsEmployeesItems,
            "GranTotalCash": effectiveCashDisplay,
            "GranTotalTransfer": effectiveTransferDisplay,
            "Date": fecha,
            "userId": userId,
            "CentralOfficeId": sucursalSelect.value
        }

        api(SERVICE.closeCorte, payload, "POST")
            .then((data) => {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Corte de caja realizado correctamente",
                    text: "Ahora se descargará el reporte",
                    showConfirmButton: false,
                    timer: 1500
                });
                handleUpdate();
                setTimeout(() => {
                    downloadReport();
                }, 1500);
            })
            .catch((err) => {
                console.log(err);
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Error al realizar el corte",
                    text: "Inténtalo de nuevo",
                    showConfirmButton: true
                });
            })
            .finally(() => {
            })
    }
    const handleCorte = () => {
        const tienePermisoEditar = permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1;

        if (!tienePermisoEditar) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Sin permisos",
                text: "No tiene permisos para realizar el corte de caja",
                showConfirmButton: true
            });
            return;
        }

        Swal.fire({
            title: "<div>Se Realizará el corte de caja del día <b>" + fecha + "</b> y sucursal: <b>" + sucursalSelect.label + "</b></div>",
            showCancelButton: true,
            confirmButtonText: "ACEPTAR",
            confirmButtonColor: "#079459",
            cancelButtonText: "CANCELAR"
        })
            .then((result) => {
                if (result.isConfirmed) {
                    
                    let payload = {
                        "Billing": dataTotals.billing,
                        "Liquidations": dataTotals.liquidations,
                        "Recoveries": dataTotals.recoveries,
                        "AdvancePayments": dataTotals.advancePayments,
                        "Disbursements": dataTotals.disbursements,
                        "PreviousCut": dataTotals.previousCut,
                        "TotalContributions": dataTotals.totalContributions,
                        "TotalDeductions": dataTotals.totalDeductions,
                        "PartialPayments": dataTotals.partialPayments,
                        "GranTotal": dataTotals.granTotal,
                        "BillingEmployees": dataTotals.billingEmployees,
                        "DisbursementsEmployees": dataTotals.disbursementsEmployees,
                        "BillingEmployeesItems": dataTotals.billingEmployeesItems,
                        "DisbursementsEmployeesItems": dataTotals.disbursementsEmployeesItems,
                        "GranTotalCash": effectiveCashDisplay,
                        "GranTotalTransfer": effectiveTransferDisplay,
                        "Date": fecha,
                        "userId": userId,
                        "CentralOfficeId": sucursalSelect.value
                    }
                    api(SERVICE.closeCorte, payload, "POST")
                        .then((data) => {
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Corte de caja correcto",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            handleUpdate();

                        })
                        .catch((err) => {
                            console.log(err);
                        })
                        .finally(() => {
                            
                        })
                }
            })

    }
    const handleDeleteAndRefresh = () => {
        // Verificar si tiene permisos para editar corte
        const tienePermisoEditar = permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1;

        if (!tienePermisoEditar) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Sin permisos",
                text: "No tiene permisos para rehacer el corte de caja",
                showConfirmButton: true
            });
            return;
        }

        if (dataTotals.Id !== 0) {
            Swal.fire({
                title: "Esta segur@ que desea rehacer el corte de caja ?",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                denyButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    api(SERVICE.eliminarCorte + `?Id=${dataTotals.id}`, {}, "DELETE")
                        .then((data) => {
                            handleUpdate();
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                }
            });
        }
    }

    const handleUpdate = useCallback(() => {
        console.log(dataTotals.id);
        if (fecha !== "" && fecha !== null && sucursalSelect !== null) {
            setLoading(true);

            api(SERVICE.getInfoCorte + `?date=${fecha}&centralOfficeId=${sucursalSelect.value}`)
                .then((data) => {

                    if (data.data.data) {
                        const info = data.data.data;
                        setDataTable(info.dataByAdvisor);
                        setDataTotals(info.grandTotals);
                        setDataEmployees(info.dataEmployees || {});
                    }
                    else {
                        setDataTable([]);
                        setDataTotals({});
                        setDataEmployees({});
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
        else {
            setDataTable([]);
            setDataTotals({});
            setDataEmployees({});
        }
    }, [fecha, sucursalSelect, dataTotals.id]);
    const handleGetSucursales = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setSucursales(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const ExpandedComponentSucursales = ({ data }) => {
        const [activeTab, setActiveTab] = useState(0);
        let arrayFront = [];
        let arrayTitle = [];

        let arrayNames = ["PAGOS", "ABONOS", "RECUPERACIONES", "DESEMBOLSOS", "PENDIENTES", "ADELANTADOS", "LIQUIDADOS", "APORTACIONES_ASESOR"];

        for (let index = 0; index < arrayNames.length; index++) {
            const nameC = arrayNames[index];

            let datapayment = null
            if (nameC === "PAGOS") {
                datapayment = data.inTimePayments;
                if (datapayment && datapayment.length > 0) {
                    arrayTitle.push({
                        id: index,
                        name: "Pagos en tiempo",
                        count: datapayment.length
                    });
                }
            }
            else if (nameC === "ABONOS") {
                datapayment = data.partialPayments;
                if (datapayment && datapayment.length > 0) {
                    arrayTitle.push({
                        id: index,
                        name: "Abonos",
                        count: datapayment.length
                    });
                }
            }
            else if (nameC === "RECUPERACIONES") {
                datapayment = data.recoveredPayments;
                if (datapayment && datapayment.length > 0) {
                    arrayTitle.push({
                        id: index,
                        name: "Recuperaciones",
                        count: datapayment.length
                    });
                }

            }
            else if (nameC === "DESEMBOLSOS") {
                datapayment = data.disbursements;
                if (datapayment && datapayment.length > 0) {
                    arrayTitle.push({
                        id: index,
                        name: "Desembolsos",
                        count: datapayment.length
                    });
                }
            }
            else if (nameC === "PENDIENTES") {
                datapayment = data.pendingPayments;
                if (datapayment && datapayment.length > 0) {
                    arrayTitle.push({
                        id: index,
                        name: "Pendientes",
                        count: datapayment.length
                    });
                }
            }
            else if (nameC === "ADELANTADOS") {
                datapayment = data.advancePayments;
                if (datapayment && datapayment.length > 0) {
                    arrayTitle.push({
                        id: index,
                        name: "Adelantos",
                        count: datapayment.length
                    });
                }
            }
            else if (nameC === "LIQUIDADOS") {
                datapayment = data.liquidationsPayments;
                if (datapayment && datapayment.length > 0) {
                    arrayTitle.push({
                        id: index,
                        name: "Liquidaciones",
                        count: datapayment.length
                    });
                }
            }
            else if (nameC === "APORTACIONES_ASESOR") {
                datapayment = data.contributionsAdvisors;
                if (datapayment && datapayment.length > 0) {
                    arrayTitle.push({
                        id: index,
                        name: "Aportaciones Asesor",
                        count: datapayment.length
                    });
                }
            }
            let arrayData = [];
            if (datapayment && datapayment.length > 0) {
                if (nameC === "DESEMBOLSOS") {
                    let total = 0;
                    let total2 = 0;
                    for (let index = 0; index < datapayment.length; index++) {
                        const element = datapayment[index];
                        arrayData.push(
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{element.clientName || 'Sin nombre'}</td>
                                <td>{element.amount != null ? `$ ${element.amount.toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}` : "$ 0.00"}</td>
                                <td>{element.disbursement != null ? `$ ${element.disbursement.toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}` : "$ 0.00"}</td>
                            </tr>
                        );
                        total = total + (element.amount ? element.amount : 0);
                        total2 = total2 + (element.disbursement ? element.disbursement : 0);

                    }
                    arrayData.push(
                        <tr key="total">
                            <td></td>
                            <td>TOTAL</td>
                            <td style={{ fontWeight: "bold" }}>{`$ ${total.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`}</td>
                            <td style={{ fontWeight: "bold" }}>{`$ ${total2.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`}</td>
                        </tr>
                    );
                    arrayFront.push(
                        <div key={index} className={styles.advisorTablesContainer}>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="60px" scope="col">#</th>
                                        <th scope="col">CLIENTE</th>
                                        <th width="110px" scope="col">MONTO</th>
                                        <th width="110px" scope="col">DESEMB.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {arrayData}
                                </tbody>
                            </table>
                        </div>
                    );
                }
                else if (nameC === "ABONOS" || nameC === "RECUPERACIONES" || nameC === "PAGOS" || nameC === "ADELANTADOS" || nameC === "LIQUIDADOS") {
                    let total = 0;
                    for (let index = 0; index < datapayment.length; index++) {
                        const element = datapayment[index];
                        arrayData.push(
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{element.clientName || 'Sin nombre'}</td>
                                <td>{element.amountPayment != null ? `$ ${element.amountPayment.toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}` : "$ 0.00"}</td>
                            </tr>
                        );
                        total = total + (element.amountPayment ? element.amountPayment : 0);
                    }
                    arrayData.push(
                        <tr key="total">
                            <td></td>
                            <td>TOTAL</td>
                            <td style={{ fontWeight: "bold" }}>{`$ ${total.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`}</td>
                        </tr>
                    );
                    arrayFront.push(
                        <div key={index} className={styles.advisorTablesContainer}>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="200px" scope="col">#</th>
                                        <th scope="col">CLIENTE</th>
                                        <th scope="col">MONTO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {arrayData}
                                </tbody>
                            </table>
                        </div>
                    );
                }


                else if (nameC === "APORTACIONES_ASESOR") {
                    let total = 0;
                    for (let index = 0; index < datapayment.length; index++) {
                        const element = datapayment[index];
                        arrayData.push(
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{element.clientName || 'Sin nombre'}</td>
                                <td>{element.amountPaymentContributionAdvisor != null ? `$ ${element.amountPaymentContributionAdvisor.toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}` : "$ 0.00"}</td>
                                <td>{element.typeContribution || 'N/A'}</td>
                            </tr>
                        );
                        total = total + (element.amountPaymentContributionAdvisor ? element.amountPaymentContributionAdvisor : 0);
                    }
                    arrayData.push(
                        <tr key="total">
                            <td></td>
                            <td>TOTAL</td>
                            <td style={{ fontWeight: "bold" }}>{`$ ${total.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`}</td>
                            <td></td>
                        </tr>
                    );
                    arrayFront.push(
                        <div key={index} className={styles.advisorTablesContainer}>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="60px" scope="col">#</th>
                                        <th scope="col">CLIENTE</th>
                                        <th width="110px" scope="col">MONTO</th>
                                        <th width="90px" scope="col">TIPO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {arrayData}
                                </tbody>
                            </table>
                        </div>
                    );
                }
                else {
                    let total = 0;
                    for (let index = 0; index < datapayment.length; index++) {
                        const element = datapayment[index];
                        arrayData.push(
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{element.clientName || 'Sin nombre'}</td>
                                <td>{element.amount != null ? `$ ${element.amount.toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}` : element.disbursement != null ? `$ ${element.disbursement.toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}` : "$ 0.00"}</td>
                            </tr>
                        );
                        total = total + (element.amount ? element.amount : element.disbursement ? element.disbursement : 0);
                    }
                    arrayData.push(
                        <tr key="total">
                            <td></td>
                            <td>TOTAL</td>
                            <td style={{ fontWeight: "bold" }}>{`$ ${total.toLocaleString('es-MX', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}`}</td>
                        </tr>
                    );
                    arrayFront.push(
                        <div key={index} className={styles.advisorTablesContainer}>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="60px" scope="col">#</th>
                                        <th scope="col">CLIENTE</th>
                                        <th width="110px" scope="col">MONTO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {arrayData}
                                </tbody>
                            </table>
                        </div>
                    );
                }

            }

        }

        if (arrayTitle.length === 0) {
            return (
                <div style={{ padding: "20px", textAlign: "center", color: "#6c757d" }}>
                    No hay información disponible para este asesor
                </div>
            );
        }

        return (
            <>
                <div style={{ paddingLeft: "50px" }}>
                    <div
                        className={styles.advisorTabs}
                        style={{ marginBottom: '10px' }}
                    >
                        <ul
                            className="nav nav-tabs"
                            style={{
                                borderBottom: '2px solid #0e3e58',
                                marginBottom: '0',
                                paddingLeft: '0'
                            }}
                        >
                            {arrayTitle.map((tab, index) => (
                                <li
                                    key={index}
                                    className={activeTab === index ? "nav-item-active" : "nav-item"}
                                    onClick={() => setActiveTab(index)}
                                    style={{
                                        marginRight: '2px',
                                        marginBottom: '0',
                                        marginTop: '5px'
                                    }}
                                >
                                    <span
                                        className={activeTab === index ? "nav-link active" : "nav-link"}
                                        style={{
                                            backgroundColor: activeTab === index ? '#0e3e58' : 'white',
                                            color: activeTab === index ? 'white' : '#0e3e58',
                                            borderColor: activeTab === index ? '#0e3e58' : '#dee2e6',

                                            borderBottom: 'none',
                                            padding: '6px 12px',
                                            borderRadius: '6px 6px 0 0',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            display: 'block',
                                            textDecoration: 'none',
                                            fontSize: '12px',
                                            fontWeight: '500',
                                            lineHeight: '1.2'
                                        }}
                                    >
                                        {tab.name} ({tab.count})
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {arrayFront[activeTab]}
                </div>
            </>
        );
    };

    const EmployeeTabsComponent = ({ donePaymentsEmployees, pendingPaymentsEmployees, disbursementsEmployees, renderEmployeeTable }) => {
        const [activeTab, setActiveTab] = useState(0);

        // Crear array de tabs disponibles
        let availableTabs = [];
        if (donePaymentsEmployees.length > 0) {
            availableTabs.push({ name: "Pagos", data: donePaymentsEmployees, type: 'pagos' });
        }
        if (pendingPaymentsEmployees.length > 0) {
            availableTabs.push({ name: "Pendientes", data: pendingPaymentsEmployees, type: 'pendientes' });
        }
        if (disbursementsEmployees.length > 0) {
            availableTabs.push({ name: "Desembolsos", data: disbursementsEmployees, type: 'desembolsos' });
        }

        if (availableTabs.length === 0) {
            return null;
        }

        return (
            <div style={{ marginTop: '20px' }}>
                <div
                    className={styles.advisorTabs}
                    style={{ marginBottom: '10px' }}
                >
                    <ul
                        className="nav nav-tabs"
                        style={{
                            borderBottom: '2px solid #0e3e58',
                            marginBottom: '0',
                            paddingLeft: '0'
                        }}
                    >
                        {availableTabs.map((tab, index) => (
                            <li
                                key={index}
                                className={activeTab === index ? "nav-item-active" : "nav-item"}
                                onClick={() => setActiveTab(index)}
                                style={{
                                    marginRight: '2px',
                                    marginBottom: '0',
                                    marginTop: '5px'
                                }}
                            >
                                <span
                                    className={activeTab === index ? "nav-link active" : "nav-link"}
                                    style={{
                                        backgroundColor: activeTab === index ? '#0e3e58' : 'white',
                                        color: activeTab === index ? 'white' : '#0e3e58',
                                        borderColor: activeTab === index ? '#0e3e58' : '#dee2e6',
                                        borderBottom: 'none',
                                        padding: '6px 12px',
                                        borderRadius: '6px 6px 0 0',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        display: 'block',
                                        textDecoration: 'none',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        lineHeight: '1.2'
                                    }}
                                >
                                    {tab.name} ({tab.data.length})
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.advisorTablesContainer}>
                    {renderEmployeeTable(availableTabs[activeTab].data, availableTabs[activeTab].type)}
                </div>
            </div>
        );
    };

    const renderEmployeeTables = () => {
        if (!dataEmployees || Object.keys(dataEmployees).length === 0) {
            return null;
        }

        const { donePaymentsEmployees = [], pendingPaymentsEmployees = [], disbursementsEmployees = [], cobranzaEmployees = [] } = dataEmployees;

        const renderEmployeeTable = (data, type) => {
            if (!data || data.length === 0) {
                return (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                        <p>No hay datos disponibles</p>
                    </div>
                );
            }

            const firstItem = data[0];
            let fields = Object.keys(firstItem).filter(key =>
                key !== 'id' &&
                key !== 'idLoanItem' &&
                key !== 'brandLoanItem' &&
                key !== 'itemLoanItem' &&
                key !== 'descriptionLoanItem' &&
                firstItem[key] !== null && firstItem[key] !== undefined
            );

            if (type === 'pendientes') {
                fields = fields.filter(field =>
                    field !== 'amountAT' &&
                    field !== 'amountAt' &&
                    field !== 'AmountAT' &&
                    field !== 'AmountAt'
                );
            } else if (type === 'desembolsos') {
                fields = fields.filter(field => field !== 'amount' && field !== 'Amount');
            }

            if (fields.includes('clientName')) {
                fields = ['clientName', ...fields.filter(f => f !== 'clientName')];
            }

            const fieldLabels = {
                clientName: 'Cliente',
                amount: 'Monto',
                Amount: 'Monto',
                amountPayable: 'Monto a Pagar',
                amountAT: 'Monto AT',
                amountAt: 'Monto AT',
                AmountAT: 'Monto AT',
                AmountAt: 'Monto AT',
                amountPayment: 'Pago',
                amountPending: 'Monto Pendiente',
                disbursement: 'Desembolso',
                tipoPago: 'Tipo de Pago'
            };

            const formatMoney = (value) => {
                if (value === null || value === undefined) return "$ 0.00";
                return `$ ${value.toLocaleString('es-MX', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}`;
            };

            const totals = {};
            fields.forEach(field => {
                if (field !== 'clientName' && field !== 'tipoPago') {
                    totals[field] = data.reduce((sum, item) => sum + (item[field] || 0), 0);
                }
            });

            return (
                <div>
                    <table className="table">
                        <thead>
                            <tr>
                                <th width="80px" scope="col">#</th>
                                {fields.map(field => (
                                    <th key={field} scope="col">
                                        {fieldLabels[field] || field.toUpperCase()}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "14px" }}>
                            {data.map((item, index) => (
                                <tr key={index} style={{
                                    backgroundColor: '#f8f9ff',
                                    borderLeft: '4px solid #4A8DB3'
                                }}>
                                    <td>{index + 1}</td>
                                    {fields.map(field => (
                                        <td key={field}>
                                            {field === 'clientName' ? (
                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                    {item[field]}
                                                    {item.idLoanItem && item.idLoanItem !== 0 && (
                                                        <span style={{
                                                            backgroundColor: "#28a745",
                                                            color: "white",
                                                            padding: "2px 6px",
                                                            borderRadius: "10px",
                                                            fontSize: "9px",
                                                            fontWeight: "600",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px"
                                                        }}>
                                                            {item.brandLoanItem + " " + item.itemLoanItem}
                                                        </span>
                                                    )}
                                                </div>
                                            ) : field === 'tipoPago' ?
                                                item[field]
                                                : formatMoney(item[field])
                                            }
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            <tr style={{ fontWeight: "bold", backgroundColor: "#e7e8ff", borderLeft: '4px solid #4A8DB3' }}>
                                <td></td>
                                <td>TOTAL</td>
                                {fields.slice(1).map(field => (
                                    <td key={field}>
                                        {field === 'clientName' || field === 'tipoPago'
                                            ? ''
                                            : formatMoney(totals[field])
                                        }
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        };

        return (
            <div className={styles.employeeTablesContainer}>
                <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", marginBottom: "20px" }}>
                    <div style={{ flex: 1, backgroundColor: "#4A8DB3", height: "3px" }}></div>
                    <div style={{ width: "300px", textAlign: "center", fontWeight: "bold", color: "#4A8DB3", fontSize: "16px" }}>
                        RESUMEN POR EMPLEADOS
                    </div>
                    <div style={{ flex: 1, backgroundColor: "#4A8DB3", height: "3px" }}></div>
                </div>

                {cobranzaEmployees.length > 0 && (
                    <div style={{ marginBottom: "15px", padding: "10px", backgroundColor: "#f8f9ff", border: "1px solid #4A8DB3", borderRadius: "6px" }}>
                        <h6 style={{ color: "#4A8DB3", fontWeight: "bold", marginBottom: "10px", textAlign: "center", fontSize: "14px", margin: "0 0 10px 0" }}>
                            PRÉSTAMOS ACTIVOS DE EMPLEADOS
                        </h6>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "6px" }}>
                            {cobranzaEmployees.map((employee, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "6px 10px",
                                        backgroundColor: "white",
                                        border: "1px solid #dee2e6",
                                        borderRadius: "4px",
                                        borderLeft: "3px solid #4A8DB3",
                                        fontSize: "13px"
                                    }}
                                >
                                    <span style={{ fontWeight: "500", color: "#495057", flex: 1, display: "flex", alignItems: "center", gap: "8px" }}>
                                        {employee.clientName}
                                        {employee.idLoanItem && employee.idLoanItem !== 0 && (
                                            <span style={{
                                                backgroundColor: "#28a745",
                                                color: "white",
                                                padding: "2px 8px",
                                                borderRadius: "12px",
                                                fontSize: "9px",
                                                fontWeight: "600",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.5px"
                                            }}>
                                                {employee.brandLoanItem + " " + employee.itemLoanItem}
                                            </span>
                                        )}
                                    </span>
                                    <span style={{ fontWeight: "bold", color: "#4A8DB3", marginLeft: "8px" }}>
                                        $ {employee.amountPayable ? employee.amountPayable.toLocaleString('es-MX', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) : "0.00"}
                                    </span>
                                </div>
                            ))}
                        </div>
                        <div style={{
                            marginTop: "10px",
                            padding: "6px",
                            backgroundColor: "#e7e8ff",
                            borderRadius: "4px",
                            textAlign: "center",
                            borderLeft: "3px solid #4A8DB3",
                            fontSize: "13px"
                        }}>
                            <span style={{ fontWeight: "bold", color: "#4A8DB3" }}>
                                TOTAL CARTERA: $ {cobranzaEmployees.reduce((total, emp) => total + (emp.amountPayable || 0), 0).toLocaleString('es-MX', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </span>
                        </div>
                    </div>
                )}

                {/* Nuevo diseño de tabs igual al de asesores */}
                <EmployeeTabsComponent
                    donePaymentsEmployees={donePaymentsEmployees}
                    pendingPaymentsEmployees={pendingPaymentsEmployees}
                    disbursementsEmployees={disbursementsEmployees}
                    renderEmployeeTable={renderEmployeeTable}
                />
            </div>
        );
    };
    useEffect(() => {
        handleGetSucursales();
    }, [])
    useEffect(() => {
        handleUpdate();
    }, [handleUpdate])
    return (
        <>
            <WindowLayout
                title="CORTE DE CAJA"
                route={["Inicio", "Corte de Caja"]}
                actions={[() => setMenuActual("homeMenu")]}
                icon={<FaFileInvoiceDollar />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerInputs} style={{ display: "flex", justifyContent: "left" }}>
                        <div className={styles.itemFormInputs} style={{ zIndex: 3 }}>
                            <label class="form-label">Sucursal: </label>
                            <Select isClearable={true} options={sucursales} class="form-control" placeholder="Seleccione..." value={sucursalSelect} onChange={(e) => setSucursalSelect(e)} />
                        </div>
                        <div className={styles.itemFormInputs} style={{ zIndex: 2 }}>
                            <label class="form-label">Fecha de Corte: </label>
                            <input type="date" class="form-control" placeholder="Fecha de Corte" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                        </div>
                        <div className={styles.itemFormInputs} style={{ zIndex: 2, paddingTop: "28px" }}>
                            <button onClick={handleDownload} style={{ display: dataTable.length === 0 ? "none" : "" }} className='btn btn-primary'>{
                                !loadingPrint ?
                                    (
                                        <IoMdPrint ></IoMdPrint>
                                    )
                                    :
                                    (
                                        <div class="spinner-border spinner-border-sm text-light" role="status">
                                            <span class="visually-hidden"></span>
                                        </div>
                                    )
                            }</button>&nbsp;&nbsp;&nbsp;
                            {
                                (permisos.findIndex(item => item.identifier === "RefreshCorteCaja") !== -1 && permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1) ?
                                    <button onClick={handleDeleteAndRefresh} style={{ display: dataTotals.id === 0 ? "none" : dataTotals.id === undefined ? "none" : "" }} className='btn btn-info'><LuRefreshCw></LuRefreshCw></button>

                                    :
                                    <></>
                            }
                            {
                                (permisos.findIndex(item => item.identifier === "SaveEditCorteCaja") !== -1) ?
                                    <button onClick={handleCorte} style={{ display: dataTotals.id === 0 ? "" : "none" }} className='btn btn-warning'><FaSave></FaSave>&nbsp; Guardar Corte</button>
                                    :
                                    <></>
                            }

                        </div>
                    </div>
                    <div className={styles.conteMain}>
                        {
                            loading ?

                                <div className={styles.corteNoData}>
                                    <h5>Cargando...</h5>&nbsp;&nbsp;&nbsp;
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                :
                                sucursalSelect === null || fecha === "" || fecha === null ?
                                    <div className={styles.corteNoData}>
                                        <h5>Seleccione una sucursal y una fecha para empezar.</h5>
                                    </div>
                                    :
                                    dataTable.length === 0 && dataEmployees.length === 0 ?
                                        <div className={styles.corteNoData}>
                                            <h5>No se encontro información.</h5>
                                        </div>
                                        :
                                        <>

                                            <div className={`${styles.tableContainer} ${styles.dataTableCustom}`} style={{ width: "60%", display: !loading && dataTable.length > 0 ? "" : "none", position: 'relative' }}>
                                                <div style={{ position: 'relative', height: '400px', overflow: 'hidden' }}>
                                                    <div style={{ height: 'calc(100% - 60px)', overflow: 'auto' }}>
                                                        <DataTable
                                                            columns={columns}
                                                            data={dataTable}
                                                            persistTableHead
                                                            fixedHeader
                                                            fixedHeaderScrollHeight="100%"
                                                            responsive
                                                            expandableRows
                                                            expandableRowsComponent={ExpandedComponentSucursales}
                                                            customStyles={{
                                                                table: {
                                                                    style: {
                                                                        backgroundColor: 'transparent',
                                                                        borderCollapse: 'separate',
                                                                        borderSpacing: '0',
                                                                    },
                                                                },
                                                                headRow: {
                                                                    style: {
                                                                        background: 'linear-gradient(135deg, #4b8eb4 0%, #4b8eb4 100%)',
                                                                        border: 'none',
                                                                        minHeight: '40px',
                                                                    },
                                                                },
                                                                headCells: {
                                                                    style: {
                                                                        background: 'transparent',
                                                                        color: 'white',
                                                                        fontWeight: '600',
                                                                        textAlign: 'center',
                                                                        padding: '12px 8px',
                                                                        fontSize: '12px',
                                                                        textTransform: 'uppercase',
                                                                        letterSpacing: '0.3px',
                                                                        border: 'none',
                                                                    },
                                                                },
                                                                rows: {
                                                                    style: {
                                                                        borderBottom: '1px solid #e9ecef',
                                                                        backgroundColor: 'white',
                                                                        '&:nth-of-type(even)': {
                                                                            backgroundColor: '#f8f9fa',
                                                                        },
                                                                    },
                                                                },
                                                                cells: {
                                                                    style: {
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle',
                                                                        padding: '8px 6px',
                                                                        fontSize: '12px',
                                                                        border: 'none',
                                                                        color: '#495057',
                                                                    },
                                                                },
                                                                expanderRow: {
                                                                    style: {
                                                                        backgroundColor: '#f8f9fa',
                                                                    },
                                                                },
                                                                expanderButton: {
                                                                    style: {
                                                                        color: '#6c757d',
                                                                        background: 'transparent',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        padding: '4px',
                                                                        fontSize: '16px',
                                                                        fontWeight: '500',
                                                                        minWidth: '30px',
                                                                        minHeight: '30px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        transition: 'all 0.2s ease',
                                                                        cursor: 'pointer',
                                                                        '&:hover': {
                                                                            color: '#4b8eb4'
                                                                        },
                                                                        '&:active': {
                                                                            transform: 'scale(0.95)',
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Fila de totales fija */}
                                                    {permisos.findIndex(item => item.identifier === "CorteTotals") !== -1 && (
                                                        <div style={{
                                                            height: '60px',
                                                            backgroundColor: '#f8f9fa',
                                                            borderTop: '2px solid #0e3e58',
                                                            zIndex: 10,
                                                            overflow: 'auto',
                                                            width: '100%',
                                                        }}>
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '700',
                                                                color: '#0e3e58',
                                                                minHeight: '44px'
                                                            }}>
                                                                {/* Columna # */}
                                                                <div style={{ width: '90px', textAlign: 'center', padding: '8px 6px' }}>
                                                                </div>

                                                                {/* Columna Asesor */}
                                                                <div style={{ flex: 1, textAlign: 'right', padding: '8px 6px' }}>
                                                                    TOTALES:
                                                                </div>

                                                                {/* Columna Clientes */}
                                                                <div style={{ width: '80px', textAlign: 'center', padding: '8px 6px' }}>
                                                                    {dataTable.reduce((sum, row) => sum + (row.cantClients || 0), 0)}
                                                                </div>

                                                                {/* Columna Cartera real */}
                                                                <div style={{ width: '115px', textAlign: 'right', padding: '8px 6px' }}>
                                                                    $ {dataTable.reduce((sum, row) => sum + (row.amount || 0), 0).toLocaleString('es-MX', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                                </div>

                                                                {/* Columna Cartera c/interes */}
                                                                <div style={{ width: '115px', textAlign: 'right', padding: '8px 6px' }}>
                                                                    $ {dataTable.reduce((sum, row) => sum + (row.amountPayable || 0), 0).toLocaleString('es-MX', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                                </div>

                                                                {/* Columna TC */}
                                                                <div style={{ width: '115px', textAlign: 'right', padding: '8px 6px' }}>
                                                                    $ {dataTable.reduce((sum, row) => sum + (row.amountAT || 0), 0).toLocaleString('es-MX', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                                </div>

                                                                {/* Columna Pendiente */}
                                                                <div style={{ width: '125px', textAlign: 'right', padding: '8px 6px' }}>
                                                                    $ {dataTable.reduce((sum, row) => sum + (row.totalAmountPendingPayment || 0), 0).toLocaleString('es-MX', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                                </div>

                                                                {/* Columna Efectivo/Transferencia */}
                                                                <div style={{ width: '150px', textAlign: 'right', padding: '8px 6px' }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                            <FaMoneyBillWave style={{ color: '#28a745', fontSize: '12px' }} />
                                                                            <span style={{ fontSize: '11px' }}>
                                                                                $ {dataTable.reduce((sum, row) => {
                                                                                    const prefill = tcValues[row.advisorId];
                                                                                    const cash = prefill ? prefill.cash : (row.totalBilling && row.totalBilling.cashAmount !== undefined ? row.totalBilling.cashAmount : 0);
                                                                                    return sum + (parseFloat(cash) || 0);
                                                                                }, 0).toLocaleString('es-MX', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                            </span>
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                            <FaExchangeAlt style={{ color: '#0d6efd', fontSize: '12px' }} />
                                                                            <span style={{ fontSize: '11px' }}>
                                                                                $ {dataTable.reduce((sum, row) => {
                                                                                    const prefill = tcValues[row.advisorId];
                                                                                    const transfer = prefill ? prefill.transfer : (row.totalBilling && row.totalBilling.transferAmount !== undefined ? row.totalBilling.transferAmount : 0);
                                                                                    return sum + (parseFloat(transfer) || 0);
                                                                                }, 0).toLocaleString('es-MX', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {!loading && dataTable.length > 0 && renderEmployeeTables()}
                                            </div>
                                            {//-- DIV DE TOTALES --//
                                            }
                                            <div className={styles.tableContainer} style={{ flex: 1, display: !loading && dataTable.length === 0 && (JSON.stringify(dataEmployees) !== "{}") ? "" : "none" }}>

                                                {!loading && (JSON.stringify(dataEmployees) !== "{}") && renderEmployeeTables()}
                                            </div>
                                            <div className={styles.totalsContainer} style={{ flex: 1 }}>
                                                <div className={styles.itemForm} style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
                                                    <div style={{ flex: 1, backgroundColor: "#4A8DB3", height: "3px" }}></div>
                                                    <div style={{ width: "300px", textAlign: "center", fontWeight: "bold", color: "#4B8FB5" }}>INVIRTIENDO EN {sucursalSelect ? sucursalSelect.label : ""}</div>
                                                    <div style={{ flex: 1, backgroundColor: "#4A8DB3", height: "3px" }}></div>
                                                </div>

                                                <div className={styles.itemFormContainerRes}>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">Cobranza: </label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.billing ?
                                                                dataTotals.billing.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(+) Liquidaciones:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.liquidations ?
                                                                dataTotals.liquidations.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                </div>
                                                <div className={styles.itemFormContainerRes}>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(+) Recuperaciones:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.recoveries ?
                                                                dataTotals.recoveries.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(+) Pagos adelantados:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.advancePayments ?
                                                                dataTotals.advancePayments.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                </div>
                                                <div className={styles.itemFormContainerRes}>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(+) Abonos:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.partialPayments ?
                                                                dataTotals.partialPayments.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>

                                                    {/* <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">Total Pendiente:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.totalAmountPendingPayment ?
                                                                dataTotals.totalAmountPendingPayment.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div> */}
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(-) Desembolsos:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.disbursements ?
                                                                dataTotals.disbursements.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                </div>

                                                <div className={styles.itemFormContainerRes}>

                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2, position: "relative" }}>
                                                        <label className="form-label">(+) Aportaciones:</label>
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            className={`form-control ${styles.clickableInput}`}
                                                            value={
                                                                `$ ${dataTotals.totalContributions ?
                                                                    dataTotals.totalContributions.toLocaleString('es-MX', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) :
                                                                    "0.00"
                                                                }`
                                                            }
                                                            onClick={() => {
                                                                setTipo(1);
                                                                setShow(true);
                                                            }}
                                                            title="Haz clic para agregar aportaciones"
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </div>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2, position: "relative" }}>
                                                        <label className="form-label">(-) Deducciones (Gastos): </label>
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            className={`form-control ${styles.clickableInput}`}
                                                            value={
                                                                `$ ${dataTotals.totalDeductions ?
                                                                    dataTotals.totalDeductions.toLocaleString('es-MX', {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    }) :
                                                                    "0.00"
                                                                }`
                                                            }
                                                            onClick={() => {
                                                                setTipo(2);
                                                                setShow(true);
                                                            }}
                                                            title={"Haz clic para agregar deducciones"}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={styles.itemFormContainerRes}>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(+) Cobranza Empleados:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.billingEmployees ?
                                                                dataTotals.billingEmployees.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(-) Desembolsos Empleados:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.disbursementsEmployees ?
                                                                dataTotals.disbursementsEmployees.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                </div>
                                                <div className={styles.itemFormContainerRes}>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(+) Cobranza Artículos:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.billingEmployeesItems ?
                                                                dataTotals.billingEmployeesItems.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(-) Desembolsos Artículos:</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.disbursementsEmployeesItems ?
                                                                dataTotals.disbursementsEmployeesItems.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                </div>

                                                <div className={styles.itemFormContainerRes}>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(+) CORTE ANTERIOR ({dataTotals.date && dataTotals.date !== null ? dataTotals.date.split("T")[0] : ""}):</label>
                                                        <input type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.previousCut ?
                                                                dataTotals.previousCut.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <label className="form-label">(+) TOTAL CAJA:</label>
                                                        <input style={{ fontWeight: "bold" }} type="text" disabled className="form-control" value={
                                                            `$ ${dataTotals.granTotal ?
                                                                dataTotals.granTotal.toLocaleString('es-MX', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                }) :
                                                                "0.00"
                                                            }`} />
                                                    </div>
                                                </div>
                                                <div className={styles.itemFormContainerRes}>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>

                                                    </div>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                            <label className="form-label" style={{ marginBottom: '4px' }}>TOTAL CAJA Efectivo:</label>
                                                            {!corteBloqueado && (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setGranTotalCashUser(null)}
                                                                    style={{
                                                                        background: 'transparent',
                                                                        border: 'none',
                                                                        padding: '0 2px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        color: '#6c757d',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    title="Restablecer al cálculo"
                                                                >
                                                                    <FaUndo />
                                                                </button>
                                                            )}
                                                        </div>
                                                        <input
                                                            style={{ fontWeight: "bold" }}
                                                            type="number"
                                                            step="0.01"
                                                            className="form-control"
                                                            disabled={corteBloqueado}
                                                            value={granTotalCashUser !== null ? granTotalCashUser : totalCashComputed}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (val === '') {
                                                                    setGranTotalCashUser(null);
                                                                } else {
                                                                    setGranTotalCashUser(parseFloat(val));
                                                                }
                                                            }}
                                                            onBlur={() => {
                                                                if (corteBloqueado) return;
                                                                if (granTotalCashUser !== null && (isNaN(granTotalCashUser) || granTotalCashUser < 0)) {
                                                                    Swal.fire("Valor inválido", "Debe ser un número mayor o igual a 0", "warning");
                                                                    setGranTotalCashUser(null);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={styles.itemFormContainerRes}>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>

                                                    </div>
                                                    <div className={styles.itemForm2} style={{ width: "50%", zIndex: 2 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                            <label className="form-label" style={{ marginBottom: '4px' }}>TOTAL CAJA Transferencia:</label>
                                                            {!corteBloqueado && (
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setGranTotalTransferUser(null)}
                                                                    style={{
                                                                        background: 'transparent',
                                                                        border: 'none',
                                                                        padding: '0 2px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        color: '#6c757d',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    title="Restablecer al cálculo"
                                                                >
                                                                    <FaUndo />
                                                                </button>
                                                            )}
                                                        </div>
                                                        <input
                                                            style={{ fontWeight: "bold" }}
                                                            type="number"
                                                            step="0.01"
                                                            className="form-control"
                                                            disabled={corteBloqueado}
                                                            value={granTotalTransferUser !== null ? granTotalTransferUser : totalTransferComputed}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (val === '') {
                                                                    setGranTotalTransferUser(null);
                                                                } else {
                                                                    setGranTotalTransferUser(parseFloat(val));
                                                                }
                                                            }}
                                                            onBlur={() => {
                                                                if (corteBloqueado) return;
                                                                if (granTotalTransferUser !== null && (isNaN(granTotalTransferUser) || granTotalTransferUser < 0)) {
                                                                    Swal.fire("Valor inválido", "Debe ser un número mayor o igual a 0", "warning");
                                                                    setGranTotalTransferUser(null);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>









                                            </div>

                                        </>
                        }

                    </div>




                </div>
            </WindowLayout>
            <CorteModal
                show={show}
                setShow={setShow}
                sucursalSelect={sucursalSelect}
                handleUpdate={handleUpdate}
                tipo={tipo}
                fecha={fecha}
            ></CorteModal>
        </>
    );
} 